export default () => {
    const elements = document.querySelectorAll('.js-lazy-load-background')
    if (!elements) return
        ;
    [...elements].forEach(el => {
        el.id = el.dataset.id
        el.classList.add('o-hero__background--is-loaded')
    })
}

// WEBPACK FOOTER //
// ./src/js/modules/LazyLoadBackground.js
